<template>
  <JoszakiModal
    :open="isOpen"
    :title="$t('login.passwordRecovery.title')"
    :confirm-button-label="$t('common.send')"
    :loading="submitting"
    @cancel="$emit('close')"
    @close="$emit('close')"
    @confirm="submit"
  >
    <template #body>
      <p>{{ $t("login.passwordRecovery.description") }}</p>
      <JoszakiInput
        v-model="formData.email"
        type="email"
        :label="$t('login.provideEmail')"
        :placeholder="$t('login.emailPlaceholder')"
        :validation-state="v$.email"
      />
    </template>
  </JoszakiModal>
</template>

<script>
import { usePasswordRecoveryForm } from "./usePasswordRecoveryForm";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup(_props, context) {
    return {
      ...usePasswordRecoveryForm(context),
    };
  },
};
</script>
